<template>
  <table class="table">
      <tr>
        <td>First Name</td>
        <td>{{ userProfile.user.firstName }}</td>
      </tr>
      <tr>
        <td>Last Name</td>
        <td>{{ userProfile.user.lastName }}</td>
      </tr>
    
      <tr>
        <td>Email</td>
        <td>{{ userProfile.user.email }}</td>
      </tr>

      <tr>
        <td>Name of Institution</td>
        <td>{{ userProfile.user.nameOrg }}</td>
      </tr>

      <tr>
        <td>Title</td>
        <td>{{ userProfile.user.title }}</td>
      </tr>

      <tr>
        <td>Gender Identity</td>
        <td>{{ userProfile.user.gender }}</td>
      </tr>
      <tr>
        <td>Ethnicity</td>
        <td>{{ userProfile.user.ethnicity }}</td>
      </tr>
      <tr>
        <td>Age Range</td>
        <td>{{ userProfile.ageRange }}</td>
      </tr>
      <tr>
        <td>Years of Faculty Experience</td>
        <td>{{ userProfile.yearsOfExp }}</td>
      </tr>
      <tr>
        <td>Pronouns</td>
        <td>{{ userProfile.pronouns }}</td>
      </tr>

      <tr>
        <td>Office Address</td>
        <td>{{ userProfile.officeAddress }}</td>
      </tr>

      <tr>
        <td>Department/Program</td>
        <td>{{ userProfile.department }}</td>
      </tr>
      <tr>
        <td>Type of Institution</td>
        <td>{{ userProfile.insType }}</td>
      </tr>
      <tr>
        <td>Locationnn of Institution</td>
        <td>
          {{ userProfile.parkingAddress }} <br />
          {{ userProfile.city + " " + userProfile.state }}
        </td>
      </tr>
      <tr>
        <td>Parking Arrangement for Practitioners</td>
        <td>{{ userProfile.parkingArrangement }}</td>
      </tr>
  </table>
</template>

<script setup lang="ts">
import { Profile } from "@/types";

// eslint-disable-next-line no-undef
const props = defineProps<{
  userProfile: Profile;
}>();
</script>

<style scoped>
.table {
  width: fit-content;
  box-shadow: 0px 0px 10px 4px rgb(0 0 0 / 30%);
  border-radius: 6px;
  background:rgb(248, 248, 248);
  padding: 1rem;
  margin-top: 1rem;
  margin-left: auto;
  margin-right: auto;
}

thead td {
  text-align: center;
}

td {
  border: 2px solid #f0f0f0;
  border-collapse: collapse;
  padding: 0.2em 2em;
  font-size: larger;
  overflow-wrap: break-word;
  text-align: left;
}
</style>
